import React from 'react'
import PropTypes from 'prop-types'
import SmallText from '../texts/small-text'
import HeadingEpsilon from '../headings/heading-epsilon'
import StateTag from '../tags/state-tag'
import OrderStateTag from '../tags/order-state-tag'
import ImgCover from '../utilities/img-cover'
import CaptionText from '../texts/caption-text'
import IconButton from '../buttons/icon-button'
import { Link } from 'react-router-dom'
import values from 'lodash/values'
import { ORDER_STATE } from '../../services/myprofile/constants'

const CardHorizontal = props => {
  return (
    <div className='card horizontal'>
      <Link to={props.linkUrl} onClick={props.onClick}>
        <div className='card-caption'>
          <ImgCover src={props.imageUrl} />
        </div>
        <div className='card-body'>
          {props.showStateTag && (
            <StateTag
              iconName={props.iconStateTag}
              colorState={props.colorStateTag}
              text={props.stateTag}
            />
          )}
          {props.orderState ? (
            <OrderStateTag orderState={props.orderState} />
          ) : null}
          <HeadingEpsilon>{props.heading}</HeadingEpsilon>
          {props.time ? (
            <CaptionText className='time' light>
              {props.time}
            </CaptionText>
          ) : null}
          {props.smallText && <SmallText light>{props.smallText}</SmallText>}
          {props.caption ? (
            <CaptionText light>{props.caption}</CaptionText>
          ) : null}
          <IconButton className='action-icon' iconName='goto' />
        </div>
      </Link>
    </div>
  )
}

CardHorizontal.propTypes = {
  stateTag: PropTypes.string,
  showStateTag: PropTypes.bool,
  colorStateTag: PropTypes.string,
  iconStateTag: PropTypes.string,
  caption: PropTypes.string,
  imageUrl: PropTypes.string,
  orderState: PropTypes.oneOf(values(ORDER_STATE)),
  heading: PropTypes.string,
  smallText: PropTypes.string,
  time: PropTypes.string,
  linkUrl: PropTypes.string,
  onClick: PropTypes.func
}

CardHorizontal.defaultProps = {
  linkUrl: '/'
}

export default CardHorizontal



// WEBPACK FOOTER //
// ./src/ui/cards/card-horizontal.js